import { z } from "zod";
import { ACTIVITY_TAG_IDS } from "../constants/venue-tags";

/** Validates an activity's tags array: only known sub-tag and collection keys. */
export const activityTagsSchema = z
  .array(z.enum(ACTIVITY_TAG_IDS as [string, ...string[]]))
  .default([]);

export type ActivityTagsInput = z.infer<typeof activityTagsSchema>;
